function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 18.3877V6.64023L11.9853 1.94125L21.9706 6.64023V18.3877L11.9853 23.0866L2 18.3877Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.02936 6.64023L12.0147 11.3392L22 6.64023",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.02936 6.64023L12.0147 11.3392L22 6.64023",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.19824 4.23199L17.1836 8.93097",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9853 11.3098V23.116",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgBox = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Box.dd1f83e3.svg";
export { ForwardRef as ReactComponent };